import SelectComponent from "components/SelectG";
import InputComponent from "components/InputG";
import { IoPeopleSharp } from "react-icons/io5";
import { useState, useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { CARGO_CODES } from "constants/permissions";
import { useIniciarInscricao } from "services/api/RoletaRecepcionista/post-iniciar-inscricao";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import * as S from "./styles";
import MaterialUI from "../../../../material-UI";
import ModalConfirmacaoCaixaMae from "./components/ModalConfirmacaoCaixaMae";

const dataTurno = [
  { label: "MANHÃ", value: 1 },
  { label: "TARDE", value: 2 },
  { label: "NOITE", value: 3 },
  { label: "INTEGRAL", value: 4 },
];

interface IniciarInscricoesProps {
  dataListarFila: any;
  refetchListarFila: () => void;
  onChangeTurno: (turno: string | number) => void;
  onChangeQuantidade: (quantidade: string) => void;
  plantaoVendasId: any;
}
const IniciarInscricoes = ({
  dataListarFila,
  refetchListarFila,
  onChangeTurno,
  onChangeQuantidade,
  plantaoVendasId,
}: IniciarInscricoesProps) => {
  const [turno, setTurno] = useState<string | number>("");
  const [quantidadePosicoes, setQuantidadePosicoes] = useState<string>("");
  const [pdvCorretorSelecionado, setPdvCorretorSelecionado] =
    useState<string>("");
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);

  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const isCorretor = codigoCargo2013 === CARGO_CODES.CORRETOR;

  const { plantaoVendasData, setPlantaoVendas } = usePlantaoVendas();

  const formattedPlantaoVendas = useMemo(() => {
    if (!plantaoVendasData) return [];

    return plantaoVendasData.map((pdv: any) => ({
      value: pdv.idPdv,
      label: pdv.nome,
      idEmpreendimento: pdv.idEmpreendimento,
      nomeEmpreendimento: pdv.nomeEmpreendimento,
    }));
  }, [plantaoVendasData]);

  const { mutate: iniciarInscricao, isLoading: loadingIniciarInscricao } =
    useIniciarInscricao();

  const OnlyNumber = (e: any) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setQuantidadePosicoes(e.target.value);
    }
  };

  const submitInscricao = () => {
    onChangeQuantidade(quantidadePosicoes);
    onChangeTurno(turno);

    const idPDV = isCorretor ? pdvCorretorSelecionado : plantaoVendasId;

    iniciarInscricao(
      {
        idPlantaoVendas: idPDV,
        codigoTurno: turno,
        quantidadePosicoes,
      },
      {
        onSuccess: () => {
          refetchListarFila();
          setOpenModalConfirmacao(false);
        },
      }
    );
  };

  const handleIniciarFila = () => {
    if (isCorretor) {
      setOpenModalConfirmacao(true);
    } else {
      submitInscricao();
    }
  };

  const verifyIniciarInscricao = () => {
    if (turno === "") {
      return true;
    }
    if (quantidadePosicoes === "") {
      return true;
    }
    if (quantidadePosicoes === "0") {
      return true;
    }
    if (isCorretor && !pdvCorretorSelecionado) {
      return true;
    }
    if (dataListarFila !== null) {
      return true;
    }
    return false;
  };

  const handleTurno = (e: any) => {
    setTurno(e.target.value);
    onChangeTurno(e.target.value);
  };

  const handlePDV = (e: any) => {
    const selectedValue = e.target.value;

    // Reset dos campos ao trocar PDV
    setTurno("");
    setQuantidadePosicoes("");

    setPdvCorretorSelecionado(selectedValue);

    const selectedPDV = formattedPlantaoVendas.find(
      (pdv) => pdv.value === selectedValue
    );
    if (selectedPDV) {
      setPlantaoVendas(selectedPDV);
    }
  };

  return (
    <S.Container>
      <S.ContentTitle>
        <S.Title>Roleta</S.Title>
      </S.ContentTitle>
      <S.Line />
      <S.ContentBody>
        <S.Row>
          {isCorretor && (
            <S.Column>
              <S.Subtitle>PDV</S.Subtitle>

              <SelectComponent
                data={formattedPlantaoVendas}
                value={pdvCorretorSelecionado}
                onChange={handlePDV}
                placeholder="Selecione"
                width="177px"
              />
            </S.Column>
          )}

          {(!isCorretor || pdvCorretorSelecionado) && (
            <>
              <S.Column>
                <S.Subtitle>Turno</S.Subtitle>

                <SelectComponent
                  data={dataTurno}
                  value={turno}
                  onChange={(e) => handleTurno(e)}
                  placeholder="Selecione"
                  width="177px"
                />
              </S.Column>

              <S.Column>
                <S.Subtitle>Quantidade de posições na fila</S.Subtitle>

                <InputComponent
                  onChange={OnlyNumber}
                  value={quantidadePosicoes}
                  placeholder="Digite o número"
                />
              </S.Column>

              <S.Column>
                <S.Button
                  onClick={handleIniciarFila}
                  disabled={verifyIniciarInscricao()}
                >
                  {loadingIniciarInscricao ? (
                    <MaterialUI.CircularProgress size={20} color="inherit" />
                  ) : (
                    <>
                      <IoPeopleSharp size={20} /> Iniciar inscrições na fila
                    </>
                  )}
                </S.Button>
              </S.Column>
            </>
          )}
        </S.Row>
      </S.ContentBody>
      <ModalConfirmacaoCaixaMae
        open={openModalConfirmacao}
        setOpen={setOpenModalConfirmacao}
        onConfirm={submitInscricao}
        isLoading={loadingIniciarInscricao}
      />
    </S.Container>
  );
};

export default IniciarInscricoes;
